import { bl_datalib_weather_forecast_RowClass } from '../../dbschema/bl_datalib_weather_forecast.model';
import { BaseContainerModel } from '../base-container.model';

export class WeatherContainerModel extends BaseContainerModel {
	bl_datalib_weather_forecast: bl_datalib_weather_forecast_RowClass = new bl_datalib_weather_forecast_RowClass();
}
